import { render, staticRenderFns } from "./DirectoryPagination.vue?vue&type=template&id=51c4a8f2&scoped=true&"
import script from "./DirectoryPagination.vue?vue&type=script&lang=js&"
export * from "./DirectoryPagination.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryPagination.vue?vue&type=style&index=0&id=51c4a8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4a8f2",
  null
  
)

export default component.exports